/**
 * Settings Page
 *
 * Mobile-only page for user settings
 * Includes sign out functionality with desktop-styled button
 */

import { useAuth } from '@/contexts/AuthContext';
import './Settings.css';

export function Settings(): JSX.Element {
  const { user, signOut } = useAuth();

  return (
    <div className="settings">
      <div className="settings__header">
        <h1 className="settings__title">Settings</h1>
      </div>

      <div className="settings__content">
        <div className="settings__section">
          <h2 className="settings__section-title">Account</h2>

          <div className="settings__user">
            <div className="settings__user-avatar">
              {user?.email?.charAt(0).toUpperCase() ?? 'U'}
            </div>
            <div className="settings__user-info">
              <div className="settings__user-email">{user?.email ?? 'Guest'}</div>
            </div>
          </div>

          <button
            className="settings__signout"
            onClick={() => signOut()}
            type="button"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
